import { render, staticRenderFns } from "./SchemaContentShape.vue?vue&type=template&id=97bd313c&scoped=true"
import script from "./SchemaContentShape.vue?vue&type=script&lang=js"
export * from "./SchemaContentShape.vue?vue&type=script&lang=js"
import style0 from "./SchemaContentShape.vue?vue&type=style&index=0&id=97bd313c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd313c",
  null
  
)

export default component.exports